'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var StyledTextBreak = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin: 24px 0;\n"], ["\n  display: flex;\n  align-items: center;\n  margin: 24px 0;\n"])));
var Line = styled__default.span(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    width: 8px;\n    height: 1px;\n    background-color: ", ";\n"], ["\n    width: 8px;\n    height: 1px;\n    background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var Text = styled__default.span(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  font: bold 12px/22px ", ";\n  margin: 0 4px;\n"], ["\n  color: ", ";\n  font: bold 12px/22px ", ";\n  margin: 0 4px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var TextBreak = function (_a) {
    var children = _a.children, restProps = tslib_es6.__rest(_a, ["children"]);
    return (React__default.createElement(StyledTextBreak, tslib_es6.__assign({}, restProps),
        React__default.createElement(Line, { "data-testid": "line" }),
        React__default.createElement(Text, null, children),
        React__default.createElement(Line, { "data-testid": "line" })));
};
var templateObject_1, templateObject_2, templateObject_3;

exports.TextBreak = TextBreak;
